<template>
    <el-container class="full-screen">
        <el-aside width="250px">
            <div class="logo-box">
                <img src="../assets/img/logo.png" width="70px">
                <h1>供应商平台</h1>
            </div>
            <!-- 菜单在此 -->
            <side-menu @select="selectMenu"></side-menu>
            <img class="subscript-show" src="../assets/img/subscript-icon.png" width="100px">
        </el-aside>
        <!-- 主窗体 -->
        <div class="main-show">
            <div class="top-show clearfix">
                <span style="color: #1b8fe6">当前账号：</span>
                <span style="font-size: smaller"><i>{{currentUsername}}</i></span>
                <span style="margin-left: 20px; color: #1b8fe6">角色：</span>
                <span style="font-size: smaller"><i>{{currentRole}}</i></span>
                <div class="right-box">
                    <ul>
                        <li v-show="isShowStampBtn">
                            <el-popover
                                placement="bottom"
                                width="180"
                                trigger="click" v-model="stampVisible">
                                <div class="close-bar">
                                    <span style="font-size: 25px; line-height: 25px" @click="closeStamp">×</span>
                                </div>

                                <el-upload
                                    class="avatar-uploader"
                                    action=""
                                    :show-file-list="false"
                                    :before-upload="beforeAvatarUpload"
                                    :http-request="uploadStamp">
                                    <img v-if="stampUrl" :src="stampUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button type="text" slot="reference"><i class="el-icon-paperclip"></i>{{stampWordInfo}}</el-button>
                            </el-popover>
                        </li>
                        <li v-show="isShowMsgBtn">
                            <el-badge is-dot class="badge-item" :hidden="isHidden">
                            </el-badge>
                            <el-button type="text" @click="showNotices">
                                <i class="el-icon-bell"></i>
                                消息
                            </el-button>
                        </li>
                        <li>
                            <el-popover
                                placement="bottom"
                                width="250"
                                trigger="click" v-model="showBar">

                                <div class="close-bar">
                                    <span style="font-size: 25px; line-height: 25px" @click="closeBar">×</span>
                                </div>
                                <div class="main-bar">
                                    <el-avatar :size="50" :src="currentUser.smallAvatar" @error="errorHandler">
                                        <i class="el-icon-picture-outline"></i>
                                    </el-avatar>
                                    <span>{{ this.currentUser.name }}</span>
                                </div>
                                <div class="foot-bar">
                                    <el-row>
                                        <el-col :span="12"><span @click="changeShowBar('userInfo')">用户信息</span></el-col>
                                        <el-col :span="12"><span @click="changeShowBar('pwd')">修改密码</span></el-col>
                                    </el-row>
                                </div>
                                <!-- 用户信息 -->
                                <div class="userInfo-box" v-show="changeUserInfo">

                                    <div class="file">
                                        <el-avatar :size="50" :src="imageUrl" @error="errorHandler">
                                            <i class="el-icon-picture-outline"></i>
                                        </el-avatar>
                                        <input type="file" @change="tirggerFile($event)"/>
                                    </div>
                                    <el-form :model="userInfoForm" :rules="userInfoRules" ref="userInfoForm"
                                             label-width="40px" size="mini" style="margin-top: 10px">
                                        <el-form-item label="姓名" prop="name">
                                            <el-input v-model="userInfoForm.manname" maxlength="20"></el-input>
                                        </el-form-item>
                                        <el-form-item label="电话" prop="phone">
                                            <el-input v-model="userInfoForm.mobile" maxlength="19"></el-input>
                                        </el-form-item>
                                        <el-form-item label="备注" prop="note">
                                            <el-input v-model="userInfoForm.note" maxlength="200"></el-input>
                                        </el-form-item>
                                    </el-form>
                                    <el-button size="mini" type="primary" style="float: right"
                                               @click="submitForm('userInfo')">保存
                                    </el-button>
                                </div>
                                <!-- 修改密码 -->
                                <div class="changePwd-box" v-show="changePwd">
                                    <el-form :model="changPwdForm" :rules="changPwdRules" ref="changPwdForm"
                                             label-width="80px" size="mini" style="margin-top: 10px">
                                        <el-form-item label="原密码" prop="oldPassword">
                                            <el-input v-model="changPwdForm.oldPassword" show-password></el-input>
                                        </el-form-item>
                                        <el-form-item label="新密码" prop="newPassword">
                                            <el-input v-model="changPwdForm.newPassword" show-password></el-input>
                                        </el-form-item>
                                        <el-form-item label="确认密码" prop="confirmPassword">
                                            <el-input v-model="changPwdForm.confirmPassword" show-password></el-input>
                                        </el-form-item>
                                    </el-form>
                                    <el-button size="mini" type="primary" style="float: right"
                                               @click="submitForm('pwd')">保存
                                    </el-button>
                                </div>
                                <el-button type="text" slot="reference"><i class="el-icon-user"></i>个人中心</el-button>
                            </el-popover>
                        </li>
                        <li>
                            <el-button type="text" @click="logout">
                                <i class="el-icon-switch-button"></i>
                                退出
                            </el-button>
                        </li>
                    </ul>
                </div>
            </div>
            <el-main>
                <router-view></router-view>
                <el-dialog
                        :close-on-click-modal="false"
                        :close-on-press-escape = "false"
                        title="修改密码"
                        :show-close = "false"
                        :visible.sync="forceModifyPwdDialogVisible"
                        width="500px">
                    <el-form :model="forceModifyPwdForm" :rules="changPwdRules" ref="modifyPwdForm">
                        <el-form-item label="新密码" label-width="100px" prop = "newPassword">
                            <el-input v-model="forceModifyPwdForm.newPassword" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" label-width="100px" prop = "confirmPassword">
                            <el-input v-model="forceModifyPwdForm.confirmPassword" show-password></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="forceModifyPwd">修改</el-button>
                    </span>
                </el-dialog>
            </el-main>


        </div>
    </el-container>
</template>

<script>
import SideMenu from "../component/sidemenu";
import {mapState} from "vuex";

export default {
    name: "home",
    components: {SideMenu},
    data() {
        return {
            forceModifyPwdDialogVisible: false,
            forceModifyPwdForm: {
                newPassword: '',
                confirmPassword: ''
            },
            imageUrl: '',
            stampVisible: false,
            stampForm: {},
            titleShow: 'dashboard',
            // 刷新token锁
            refreshLock: false,
            // 刷新token的时间
            refreshTime: '',
            showBar: false,
            changeUserInfo: false,
            changePwd: false,
            userInfoForm: {
                manname: '',
                mobile: '',
                note: ''
            },
            userInfoRules: {},
            changPwdForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            changPwdRules: {
                oldPassword: [
                    {required: true, message: '请输入原密码', trigger: 'blur'}
                ],
                newPassword: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
                ],
                confirmPassword: [
                    {required: true, message: '请确认新密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
                ]
            }
        }
    },
    computed: {
        ...mapState('login', ['noReadMessageList', 'currentUser', 'stampUrl']),
        isHidden: function () {
            if (this.$store.state.login.noReadMessageList.length === 0) {
                return true;
            }
            return false;
        },
        isShowMsgBtn: function () {
            if (this.$store.state.login.currentUser.role === 1 || this.$store.state.login.currentUser.role === 2) {
                return true;
            }
            return false;
        },
        isShowStampBtn: function () {
            if (this.$store.state.login.currentUser.role === 1 || this.$store.state.login.currentUser.role === 3) {
                return true;
            }
            return false;
        },
        currentUsername: function () {
            let curUser;
            const currentUser =  this.$store.state.login.currentUser
            curUser = currentUser.username;
            return curUser;
        },
        currentRole: function () {
            let curRole;
            const currentUser =  this.$store.state.login.currentUser
            if(currentUser.role === 0){
                curRole = '管理员';
            }
            if(currentUser.role === 1){
                curRole = '主账号';
            }
            if(currentUser.role === 2){
                curRole = '子账号';
            }
            if(currentUser.role === 3){
                curRole = '采购员';
            }
            return curRole;
        },
        stampWordInfo: function () {
            const currentUser =  this.$store.state.login.currentUser
            let stampWordInfo;
            if(currentUser.role === 1 || currentUser.role === 2){
                stampWordInfo = '供应商印章';
            }
            if(currentUser.role === 3){
                stampWordInfo = '采购方印章';
            }
            return stampWordInfo;
        }
    },
    methods: {
        closeStamp() {
            this.stampVisible = false;
        },
        uploadStamp(content) {
            this.stampForm.stampFile = content.file;
            // this.stampForm.id = this.$store.state.login.currentUser.pkSupplier;
            this.$store.dispatch('system/vendorManagement/uploadStamp', this.stampForm).then((res) => {
                if (res.code === '200') {
                    this.$message({
                        message: '印章上传成功！',
                        type: 'success'
                    });
                    const render = new FileReader();
                    render.readAsDataURL(content.file);
                    render.onload = (e) => {
                        this.$store.commit('login/SET_STAMP', render.result)
                    };
                }else{
                    this.$message.error(res.data?res.data : res.message);
                }
            });
        },
        selectMenu(item, index, path) {
            this.$router.push(item.link);
            // if (item.route) {
            //     this.$router.push(item.link);
            // } else {
            //     window.location.href = item.link;
            // }
        },
        showNotices() {
            this.$router.push('/system/messageManagement');

        },
        forceModifyPwd() {
            if(this.forceModifyPwdForm.confirmPassword !== this.forceModifyPwdForm.newPassword) {
                this.$message.error("新密码和确认密码不一致，请重新输入!");
                return false;
            }
            //修改密码
            this.$store.dispatch('system/user/forceModifyPwd', this.forceModifyPwdForm).then((res) => {
                if (res.code === '200') {
                    this.forceModifyPwdDialogVisible = false;
                    this.$message.success('操作成功');
                }else{
                    this.$message.error(res.data?res.data : res.message);
                }
            });
        },

        submitForm(type) {
            if (type === 'pwd') {
                if(this.changPwdForm.confirmPassword !== this.changPwdForm.newPassword) {
                    this.$message.error("新密码和确认密码不一致，请重新输入!");
                    return false;
                }
                //修改密码
                this.$store.dispatch('system/user/changePwd', this.changPwdForm).then((res) => {
                    if (res.code === '200') {
                        this.$message.success('操作成功');
                        this.changPwdForm = {
                            oldPassword: '',
                            newPassword: '',
                            confirmPassword: ''
                        };
                        this.changePwd = false;
                        this.$store.dispatch("login/logout", this.loginUser).then((res) => {
                            if (res.status == 200) {
                                window.sessionStorage.clear();
                                this.$router.push("/login");
                            }
                        });
                    }else{
                        this.$message.error(res.data?res.data : res.message);
                    }
                });
            } else {
                //修改个人信息
                this.userInfoForm.id = this.currentUser.id;
                if (!this.userInfoForm.file || !this.userInfoForm.file.size) {
                    delete this.userInfoForm.file;
                }
                this.$store.dispatch('system/user/changeUserInfo', this.userInfoForm).then((res) => {
                    if (res.code === '200') {
                        this.$message({
                            message: '操作成功！',
                            type: 'success'
                        });
                        this.currentUser.username = this.userInfoForm.username;
                        this.currentUser.mobile = this.userInfoForm.mobile;
                        this.currentUser.note = this.userInfoForm.note;
                        this.currentUser.smallAvatar = this.imageUrl;
                        this.changeUserInfo = false;
                    }else{
                        this.$message.error(res.data?res.data : res.message);
                    }
                });
            }
        },
        closeBar() {
            //关闭个人中心
            this.showBar = false;
            if (this.changeUserInfo) {
                this.changeUserInfo = false;
            }
            if (this.changePwd) {
                this.changePwd = false;
            }
        },
        changeShowBar(type) {
            //个人中心
            if (type === 'pwd') {
                if (this.changeUserInfo) {
                    this.changeUserInfo = false;
                }
                this.changePwd = !this.changePwd;
            } else {
                this.userInfoForm.manname = this.currentUser.manname;
                this.userInfoForm.mobile = this.currentUser.mobile;
                this.userInfoForm.note = this.currentUser.note;
                this.imageUrl = this.currentUser.smallAvatar;
                if (this.changePwd) {
                    this.changePwd = false;
                }
                this.changeUserInfo = !this.changeUserInfo;
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' ||
                file.type === 'image/jpg';
            const isLt2M = file.size / 1024 / 1024 < 1;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 1MB!');
            }
            return isJPG && isLt2M;
        },
        tirggerFile(event) {
            if (!event || !window.FileReader) return; // 看支持不支持FileReader
            var file = event.target.files[0];
            if (!this.beforeAvatarUpload(file)) {
                return;
            }
            this.userInfoForm.file = file;
            var freader = new FileReader();
            freader.readAsDataURL(file);
            freader.onload = (e) => {
                this.imageUrl = freader.result;
            };
        },
        logout() {
            this.$confirm('注销当前用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.$store.dispatch("login/logout", this.loginUser).then((res) => {
                    if (res.status == 200) {
                        window.sessionStorage.clear();
                        this.$router.push("/login");
                        if (this.$store.state.login.ws) {
                            this.$store.state.login.ws.close();
                        }
                    }
                });
            });
        },
        refreshToken() {
            let store = this.$store;
            let refreshLock = this.refreshLock;
            let refreshTime = this.refreshTime;
            this.refreshTime = setInterval(() => {
                if (window.sessionStorage.getItem('wh-access-token')) {
                    let expires_in = window.sessionStorage.getItem('wh-expires-in');
                    if (expires_in <= 1000 && !refreshLock) {
                        refreshLock = true;
                        store.dispatch('login/RefreshToken').then((res) => {
                            if (res.data.access_token.accessToken !== '') {
                                window.sessionStorage.setItem('wh-access-token', res.data.access_token);
                                window.sessionStorage.setItem('wh-refresh-token', res.data.refresh_token);
                                window.sessionStorage.setItem('wh-expires-in', res.data.expires_in);
                            }
                        }).catch(() => {
                            clearInterval(refreshTime);
                        });
                        refreshLock = false;
                    }
                    window.sessionStorage.setItem('wh-expires-in', window.sessionStorage.getItem('wh-expires-in') - 10);
                }
            }, 10000);
        },
        errorHandler() {
            return true;
        }
    },
    mounted() {
        if(this.currentUser.pwdModifyTimes === 0){
            this.forceModifyPwdDialogVisible = true;
        }else{
            this.forceModifyPwdDialogVisible = false;
        }
    },
    created() {
        this.refreshToken();
        if (!this.$store.state.login.currentUser.id) {
            this.$store.dispatch('login/loadUser').then((res) => {
                let data = res.data.data;
                if (data) {
                    window.sessionStorage.setItem('wh-user', JSON.stringify(data));
                }
            });
        } else {
            this.$store.dispatch('login/getStamp');
        }
    },
    watch: {
        showBar() {
            if (!this.showBar) {
                if (this.changeUserInfo) {
                    this.changeUserInfo = false;
                }
                if (this.changePwd) {
                    this.changePwd = false;
                }
            }
        }
    }
}
</script>

<style scoped>
.top-show {
    background-color: white;
    height: 50px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 20px;
    font-size: 13px;
}

.top-show span {
    color: #535353;
}

.top-show ul li {
    float: left;
}

.top-show .right-box {
    height: 100%;
    position: absolute;
    right: 20px;
    line-height: 50px;
    top: 0;
}
.right-box .el-button {
    font-size: 16px;
}
.top-show .right-box .badge-item {
    right: -60px;
    top: -5px;
}

.main-show {
    height: 100%;
    width: calc(100% - 250px);
    background-color: #ECEDF1;
}

.main-show .el-main {
    padding: 0;
    height: calc(100% - 50px);
}

.el-aside {
    background-color: #2563AA;
}

.el-aside .subscript-show {
    position: absolute;
    bottom: 0;
}

.logo-box {
    text-align: center;
    margin: 20px 0;
}

.logo-box h1 {
    color: white;
    font-weight: normal;
    font-size: 28px;
}

.el-button i {
    font-size: 17px;
}

.el-popover {
    background-color: #2563AA;
}

.close-bar {
    height: 25px;
    width: 100%;
}

.close-bar span {
    display: block;
    float: right;
    cursor: pointer;
}

.close-bar span:hover {
    color: #4885CA;
}

.main-bar .el-avatar {
    vertical-align: middle;
    margin-right: 10px;
    border: 1px solid #979696;
    border-radius: 50%;
}

.foot-bar {
    margin-top: 20px;
    text-align: center;
}

.foot-bar span {
    cursor: pointer;
}

.foot-bar span:hover {
    color: #4885CA;
}

.foot-bar .el-col:first-child {
    border-right: 1px solid #D9D4D4;
}

.userInfo-box {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #D9D4D4;
    text-align: center;
}

.changePwd-box {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #D9D4D4;
    text-align: center;
}

.userInfo-box span {
    cursor: pointer;
}

.userInfo-box span:hover {
    color: #4885CA;
}

.userInfo-box .el-avatar {
    border: 1px solid #979696;
    border-radius: 50%;
    vertical-align: baseline;
}

.file {
    width: 50px;
    height: 50px;
    position: relative;
    overflow: hidden;
    font-size: 25px;
    margin: 0 auto;
}

.file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #4885CA;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
